import { createStore, compose, applyMiddleware } from 'redux'

export default (reducers, middlewares) => {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  const enhancer = composeEnhancers(applyMiddleware(...middlewares))

  return createStore(reducers, enhancer)
}
